import React from 'react';
import './Migration.css';
import img from '../../img/jile7.jpg';

const Migration = () => {
  return (
    <section className="migration" id="LayoutGrid6">
      <div className="migration-overlay"></div>
      <div className="container">
        <div className="migration-content">
          <div className="migration-row">
            <div className="migration-col migration-col-image">
              {/* <div className="migration-image-spacer"></div> */}
              <div className="migration-image">
                <img src={img} alt="Миграционные услуги" />
              </div>
              <div className="migration-image-spacer-small"></div>
            </div>
            
            <div className="migration-col migration-col-text">
              {/* <div className="migration-text-spacer"></div> */}
              <div className="migration-text-content">
                <div className="migration-description">
                  <p>
                    Многим прибывающим иностранным гражданам немедленно нужна постановка на миграционный учет, 
                    того требует закон № 109-ФЗ «О миграционном учете иностранных граждан и лиц без гражданства 
                    в Российской Федерации». Мы поможем Вам разобраться с этой задачей в самые короткие сроки. 
                    По прибытии, мы оперативно поставим Вас на миграционный учет, при возможности, оформим 
                    временную регистрацию.
                  </p>
                  <br />
                  <p>
                    Являясь собственниками жилья, мы сможем дистанционно подать все необходимые документы. 
                    Вы не будете самостоятельно посещать Федеральную Налоговую службу, МВД или МФЦ, заполнять 
                    бланки, разбираться в бумагах, общаться исполнителями из государственных органов.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Migration;